export default __webpack_public_path__ + "5a9b4fe5139e4c81919d56e07f2483a2.wav";